import { Stack } from "@mui/material";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import TextEditorInput from "../../../../components/form/TextEditorInput";
import TemplateAutoComplete from "../../form/TemplateAutoComplete";
import { GlobalDataContext } from "../../../../contexts/GlobalData";
import {
  EDIT_TREATMENT,
  VIEW_TEMPLATES,
} from "../../../../enums/PermissionTitles";
import { TemplateCategory } from "../../../../enums/TemplateCategory";

export default function DoctorsLetter({ name = "description", category = TemplateCategory.APPOINTMENT }) {
  const { isPermissionAllowed } = React.useContext(GlobalDataContext);
  const methods = useFormContext();
  async function handleSetValue(value) {
    methods.setValue(name, value?.description);
  }
  return (
    <Stack width={"100%"} spacing={5}>
      {isPermissionAllowed(VIEW_TEMPLATES) && (
        <TemplateAutoComplete
          control={methods.control}
          handleSetValue={(value) => handleSetValue(value)}
          category={category}
        />
      )}
      <Controller
        control={methods.control}
        name={name}
        render={({ field }) => {
          return (
            <TextEditorInput
              {...field}
              disable={!isPermissionAllowed(EDIT_TREATMENT)}
              onChange={field.onChange}
              xs={280}
              sm={500}
              md={850}
              testId="appointment.finish-meeting.doctors-letter.description-input"
            />
          );
        }}
      />
    </Stack>
  );
}
